var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    xmlSpace: "preserve",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAVxJREFUOE+tlGFVw0AQhGccIIE4AAUtCpAAVQAOAAWAAoqDOoAqoA6IA+pge3NvL++S3LUJcH/yXt7etzOzmxD/cMzsDMCS5IZ/4TnoDsA9AEEvfwU0s/Mg5BHAzUBQMwtoZksAD7JXcLYmuZoELID2AN4BbAB8OLwh2R4FVkCvIa8Xkvtgfe22ozqBi0Azu/XCZE2KOpAueo7fuboe0CcmkKam0HVGoJRdSV0H9G5fPnq9b4P6J5KyNDper+zUOGaXiqJlt/g2uKmiTwBbPfNLZqZJa222JHsT7zI0swtfBxUsMrXJupQoAglQdlJ3FYBq2p3qlLMGKdOVIsjcjNRVp5x3NDN9Vs9BUVyNTF1sMAz45GK7Ug0sDgqAsm5JNqWBnQR6Zj+eqTLUT6CobpJlB+oTu3ZFVXVzgClH3amqmwPUSsUca9n1FrsU7vCdr8uO5O5Y/aShTGmYag7IvJVfBYsekwAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.83bd3020841f38737637b5b143ae3501.svg";
export { ForwardRef as ReactComponent };